<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
    >
      <el-form-item label="原因">
        <el-input
          v-model="form.errorDesc"
          type="textarea"
          placeholder="请输入内容"
        />
      </el-form-item>
      <el-row>
        <el-button
          type="primary"
          style="margin-left:10px"
          @click="ToExamine('REJECT')"
        >
          驳回
        </el-button>
        <el-button
          type="primary"
          @click="ToExamine('AUDITED')"
        >
          通过
        </el-button>
        <el-button @click="cancel()">
          取消
        </el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { withdrawAudit } from "@/api/InternetBanking";
export default {
  data() {
    return {
      form:{},
      formData: {
        errorDesc: "",
        status: "",
        code: ""
      }
    };
  },
  created() {},
  methods: {
    findCode(c) {
      this.form = Object.assign({},this.formData)
      this.form.code = c;
    },
    ToExamine(a) {
      this.form.status = a;
      if (a == "REJECT") {
        if (this.form.errorDesc == "") {
          this.$message({
            message: "请输入驳回原因",
            type: "warning"
          });
          return false;
        }
      }
      withdrawAudit(this.form).then(response => {
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.$emit("event2");
      });
    },
    cancel() {
      this.$emit("event2");
    }
  }
};
</script>
<style scoped>
.el-button {
  float: right;
}
</style>
